import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

export class GlobalConfig extends BaseObject {
    constructor() {
        super();
        this._name = "";
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new GlobalConfig());
        } else if (target instanceof GlobalConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(GlobalConfig, {
    _name: alias("group", Schema.primitive()),
});